export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

export type GenderValue = (typeof GENDER_OPTIONS)[number]['value'];
